import Icon from 'app/components/Icon'
import React, { HTMLProps, useContext, useEffect, useState } from 'react'
import { ErrorGroupContext } from './ErrorGroup'
import { FormContext } from './Form'

interface Props extends HTMLProps<HTMLDivElement> {
    label?: string | any
    name: string
    value: string
}

export default function OrderBy(props: Props) {

    const { className, name, value, label, ...rest } = props

    const { data, setData, errors, clearErrors } = useContext(FormContext)

    const { seterrors } = useContext(ErrorGroupContext);
    useEffect(() => {
        seterrors(e => ({ ...e, [name]: errors[name] }))
    }, [errors[name]])

    let [asc, setAsc] = useState(true)

    return (
        // <div className="cursor-pointer">
        //     <div onClick={()=>{
        //             setData(d => ({...d, order: !asc ? "ASC" : "DESC", order_by: value}));
        //             setAsc(p => !p );             
        //         }}>
        //         <Icon className={(`transform duration-300 ${asc?"rotate-180":""} ${data["order_by"] == value?"text-green":""}`)} name="dropdown-arrow" />
        //     </div>
        // </div>
        <label className={`flex flex-col relative cursor-pointer ${className}`} >

            <div
                className="flex items-center flex-shrink-0"
                onClick={() => {
                    setData(d => ({ ...d, order: !asc ? "ASC" : "DESC", order_by: value }));
                    setAsc(p => !p);
                }}
            >
                {/* <input
                className="h-0 w-0 opacity-0 absolute"
                checked={data[name] == value}
                {...rest}
                type="radio"
                name={name}
                value={value}
                onChange={e => { setData(name, e.target.value); clearErrors(name) }}
            /> */}
                <div className=" border-white border-2 rounded-full w-24px h-24px radio flex items-center justify-center  flex-shrink-0" >
                    <div className={`${data["order_by"] == value ? '' : 'hidden'} w-14px h-14px rounded-full bg-white flex justify-center items-center`}>
                        <Icon className={(`w-20px duration-300 scale-125 text-black ${asc ? "rotate-180" : ""} `)} name="arrow-down" />
                    </div>
                </div>
                <div className="ml-16px leading-6 w-full">{label}</div>
            </div>
            <div className={`h-12px text-12 text-C86B28 ${errors[name] ? "" : "opacity-0"}`}>{errors?.[name]}</div>
        </label>
    )
}
